module.exports = __webpack_public_path__ + "static/media/users.69b726be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/users.svg
// module id = 231
// module chunks = 1